import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { UserService } from './user.service';
import { BehaviorSubject, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class QuickTransferService {
  modal2$ = new BehaviorSubject<boolean>(false);
  loggedData: any = {};
  baseUrl: any = environment.apiUrl + 'quick-transfer/';
  showAll: boolean;
  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private userService: UserService
  ) {
    const data = this.cookieService.get(environment.authName);
    try {
      this.loggedData = data ? JSON.parse(data) : {};
    } catch (e) {
      this.cookieService.delete(environment.authName);
      this.loggedData = {};
    }
  }
  getValueModal(): Observable<boolean>{
    return this.modal2$.asObservable();
  }
  giveValueModal(value: boolean){
    this.modal2$.next(value);
  }
  getUserBook(token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-user-book', { headers });
  }
  addUser(data, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'add-user', data, { headers });
  }
  deleteUser(data, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'delete-user', data, { headers });
  }
  generateAuthyPushQuickTransfer(data, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'generate-authy-push-quick-transfer', data, { headers });
  }
  checkAddUserStatus(referenceNumber, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'check-add-user-status', { referenceNumber: referenceNumber }, { headers });
  }

  transferFund(data, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'transfer-funds', data, { headers });
  }
  quickTransferHistory(data, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'quick-transfer-history?pageNo=' + data.pageNo + '&size=' + data.size, { headers });
  }
  quickReceivedHistory(data, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'quick-transfer-received?pageNo=' + data.pageNo + '&size=' + data.size, { headers });
  }
  getFeeLimit(token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-fee-limit', { headers });
  }
}
